
export const filter = () => {
  
  if ( document.querySelector('.filter-card') ) {
    //console.log("lets go");

    const filterBtns = document.querySelectorAll('input[name=filter]');
    const filterElements = document.querySelectorAll('.filter-element');
    
    //console.log(filterElements.length)
    //console.log(filterElements[0].dataset.filter)
    
    for(var i = 0; i < filterBtns.length; i++) {
      filterBtns[i].onchange = function() {
        //console.log( this.value );

        for (var f = 0; f < filterElements.length; f++) {
          if ( filterElements[f].dataset.filter != this.value ) {
            filterElements[f].classList.add("filter-element_hidden");
           } else {
            filterElements[f].classList.remove("filter-element_hidden");
          }
        }
        
      }
    }
  }



  if ( document.querySelector('.filter-products') ) {
    //console.log("lets go");

    const filterBtns = document.querySelectorAll('input[name=filter]');
    const filterElements = document.querySelectorAll('.filter-element');
    
 
    
    for(var i = 0; i < filterBtns.length; i++) {
      filterBtns[i].onchange = function() {
      

        for (var f = 0; f < filterElements.length; f++) {

          if ( this.value != "all" ) {

            if ( !filterElements[f].dataset.filter.split(",").includes( this.value ) ) {
              filterElements[f].classList.add("filter-element_hidden");
              filterElements[f].classList.add("filter-element_none");
            } else {
              filterElements[f].classList.remove("filter-element_hidden");
              filterElements[f].classList.remove("filter-element_none");
            }

          } else {
            filterElements[f].classList.remove("filter-element_hidden");
            filterElements[f].classList.remove("filter-element_none");
          }

        }
        
      }
    }
  }




  if ( document.querySelector('.tastes-element') ){

    const tastesElements = document.querySelectorAll('.tastes-element');
    //const tastesPicture = document.querySelector('.card-tastes__picture img');
    const tastesPicture = document.querySelector('.card-tastes__picture');
    const tastesDescription = document.querySelector('.card-tastes__description');

    //const tastesImageSrc = "url('../img/tastes/taste-invert.png')";

    //console.log( tastesElements.length );

    for (let i = 0; i < tastesElements.length; i++) {

      tastesElements[i].addEventListener('mouseover', function () {

        document.querySelector(".card-tastes__picture_hidden")?.classList.remove("card-tastes__picture_hidden");
        document.querySelector(".card-tastes__description_hidden")?.classList.remove("card-tastes__description_hidden");

        document.querySelector(".card-tastes__right_hidden")?.classList.remove("card-tastes__right_hidden");
        //console.log( this.dataset.img );

        
        if ( this.dataset.taste ) {
          tastesDescription.innerHTML = this.dataset.taste;
        } else {
          tastesDescription.innerHTML = "&nbsp;"
        }

        tastesPicture.style.backgroundImage = 'url(' + this.dataset.img + ')';
        //tastesPicture.src = this.dataset.img;
      });


      tastesElements[i].addEventListener('touchstart', function () {

        document.querySelector(".card-tastes__picture_hidden")?.classList.remove("card-tastes__picture_hidden");
        document.querySelector(".card-tastes__description_hidden")?.classList.remove("card-tastes__description_hidden");

        document.querySelector(".card-tastes__right_hidden")?.classList.remove("card-tastes__right_hidden");
        //console.log( this.dataset.img );

        
        if ( this.dataset.taste ) {
          tastesDescription.innerHTML = this.dataset.taste;
        } else {
          tastesDescription.innerHTML = "&nbsp;"
        }

        tastesPicture.style.backgroundImage = 'url(' + this.dataset.img + ')';
        //tastesPicture.src = this.dataset.img;
      });


    }

  }


} 